/**
 * @generated SignedSource<<2b3afe06ecdd8fddce353213cc781d31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemTeamSelect_team$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemTeamIndicator_team">;
  readonly " $fragmentType": "ListItemTeamSelect_team";
};
export type ListItemTeamSelect_team$key = {
  readonly " $data"?: ListItemTeamSelect_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemTeamSelect_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemTeamSelect_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListItemTeamIndicator_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "b3b1945430add7f56c4221b77fb2b9f4";

export default node;
